import React, {useRef, SetStateAction, useMemo} from 'react'
import Select from 'react-select';
import { ReactTooltip } from 'tooltip';

type TextRef = ReturnType<typeof useRef<HTMLTextAreaElement>>;

function VariableTip(){
    return <>
        <p>Variáveis podem enriquecer e deixar o seu template mais personalizado.</p>
        <p>Posicione o marcador no local desejado na caixa de texto abaixo e, em seguida, escolha uma variável disponível no menu.</p>
        <p className='mb-0'>Para dar ênfase coloque o texto entre dois <b>*</b> para deixá-lo em <b>negrito</b>.</p>
    </>
}

function VariableMenu({variables, onPick}:{variables:string[], onPick:(v:string) => void}){
    const options = useMemo(() => variables.map(v => ({value: v, label: v})), [variables])
    
    return <div className='d-flex'>
        <div className='flex-grow-1 me-3'>
            <Select classNamePrefix="react-select-city" placeholder="Variáveis..." noOptionsMessage={() => "Não encontrado"} 
                value={null}
                options={options}
                onChange={(e:any) => onPick(e.value)} />
        </div>
        <ReactTooltip tooltip={<VariableTip />} placement='bottom-end' delay={300} >
            <a className='link d-block pt-2'><i className='fa fa-circle-question'></i></a>
        </ReactTooltip>
    </div>
}

export function VariablePicker({textRef, variables, setText}:{textRef:TextRef, variables:string[], setText: (i:SetStateAction<string>) => void}){
    function onPick(name:string){
        const s = textRef.current.value;
        const result = s.substring(0, textRef.current.selectionStart) +  `{{${name}}}`  + s.substring(textRef.current.selectionEnd);
        setText(result);
    }

    return <VariableMenu variables={variables} onPick={onPick} />

}